<template lang="pug">
div
  v-app-bar.elevation-2.white(height="200px")
    .w-100
      grid-container.align-center(cols="auto max-content")
        router-link.white--text.pa-1(to="/")
          img.logo.w-100(:src="logo", contain, height="100%")
        v-btn(@click="drawer = !drawer", color="primary", icon)
          v-icon fas fa-bars
      v-text-field.rounded-pill.mt-8(
        v-model="search",
        label="Buscar",
        outlined,
        solo,
        flat,
        dense,
        hide-details,
        append-icon="fas fa-search"
      )
  v-navigation-drawer(v-model="drawer", fixed, temporary)
    router-link.white--text.h-100(to="/")
      img.main-header-mobile-logo.mx-8.mt-4.mb-4(:src="logo", contain)
      .d-flex.flex-column.align-center
    v-divider
    v-list-item-group(v-model="current")
      v-list(dense, nav)
        template(v-for="(route, i) in menu")
          v-list-item(
            :key="i",
            :to="route.path",
            exact-active-class="main-header-mobile-btn-active",
            link
          )
            v-list-item-icon.mr-4(v-if="route.icon")
              v-icon {{ route.icon }}
            v-list-item-content
              v-list-item-title.body-2
                .open-sans.font-weight-bold {{ route.name }}
</template>

<script>
export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    logo() {
      return this.files + this.$rest("informations").item.img;
    },
    query() {
      return this.$route.query;
    },
    search: {
      get() {
        return this.query.s || "";
      },
      set(v) {
        const query = { ...this.query };
        if (v) query.s = v;
        else delete query.s;

        delete query.p;

        this.$router.push({ path: "/produtos", query });
      },
    },
  },
  data() {
    return {
      current: this.$route.path,
      drawer: false,
    };
  },
};
</script>

<style>
.main-header-mobile-logo {
  height: 58px;
}
.main-header-mobile-btn-active {
  background: var(--v-primary-base);
  color: white !important;
}
.v-navigation-drawer {
  z-index: 9999 !important;
}
</style>
